import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { saveAs } from "file-saver";
import { firstValueFrom, tap } from "rxjs";
import { BackendHttpParameterService } from "src/app/shared/services/backend-http-parameter.service";
import { DataAnalyticsEventPublisherService } from "src/app/shared/services/data-analytics/data-analytics-event-publisher.service";
import { Product } from "src/app/shared/store/shared/product";
import { environment } from "src/environments/environment";

import {
  ApplicationDocumentType,
  CreateApplicationRequestDto,
} from "./request/create-application-request.dto";
import { ApplicationResponseDto } from "./response/create-application-response.dto";

@Injectable({
  providedIn: "root",
})
export class ApplicationHttpService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly _backendHttpParameterService: BackendHttpParameterService,
    private readonly _dataAnalyticsEventPublisherService: DataAnalyticsEventPublisherService,
  ) {}

  getApplication(product: Product, applicationId: string) {
    const baseUrl = environment.backendBaseUrl;

    const httpHeaders =
      this._backendHttpParameterService.createDefaultBackendHttpHeaders();

    return this.httpClient.get<ApplicationResponseDto>(
      baseUrl +
        `/products/${encodeURIComponent(product)}/applications/${encodeURIComponent(applicationId)}`,
      { headers: httpHeaders },
    );
  }

  createApplication(product: Product, requestDto: CreateApplicationRequestDto) {
    const baseUrl = environment.backendBaseUrl;

    const httpHeaders =
      this._backendHttpParameterService.createDefaultBackendHttpHeaders();

    return this.httpClient.post<ApplicationResponseDto>(
      baseUrl + `/products/${encodeURIComponent(product)}/applications`,
      requestDto,
      { headers: httpHeaders },
    );
  }

  async downloadApplicationPdf(
    product: Product,
    applicationId: string,
    applicationDocumentType: ApplicationDocumentType,
  ) {
    const baseUrl = environment.backendBaseUrl;

    const httpHeaders =
      this._backendHttpParameterService.createDefaultBackendHttpHeaders();

    return firstValueFrom(
      this.httpClient
        .get(
          baseUrl +
            `/products/${encodeURIComponent(product)}/applications/${encodeURIComponent(applicationId)}/documents/${encodeURIComponent(applicationDocumentType)}`,
          {
            responseType: "blob",
            headers: httpHeaders,
          },
        )
        .pipe(
          tap((pdf) => {
            const fileNameWithExtension = $localize`Antrag Todesfallversicherung.pdf`;
            this._dataAnalyticsEventPublisherService.pushFileDownloadEvent(
              fileNameWithExtension,
            );

            saveAs(pdf, fileNameWithExtension);
          }),
        ),
    );
  }
}
